<template>
  <v-container fluid pa-0 class="bg-home">
    <v-container pa-0>
      <div class="hidden-sm-and-down bg-header">
        <v-toolbar id="menu" height="70" color="transparent">
          <v-layout row wrap justify-center>
            <v-flex xs12 md12 mt-5>
              <v-toolbar-title class="w-100" style="text-align:center;">
                <span class="w-100 mt-4 title-menu" style="margin-left:10px;"
                  >รวมใจไทย ปลูกต้นไม้ เพื่อแผ่นดิน</span
                >
              </v-toolbar-title>
            </v-flex>
            <v-flex xs12 md12>
              <div class="ta-c" style="margin-top: -20px;">
                <img src="../assets/images/line.png" alt="" width="350" />
              </div>
            </v-flex>
          </v-layout>
        </v-toolbar>
        <v-toolbar
          id="sub-menu"
          height="64"
          color="transparent"
          style="display: flex;justify-content: center;"
        >
          <v-container style="display: contents; ">
            <template>
              <v-list-tile
                v-for="item in items"
                :key="item.title"
                :to="item.path == '' ? '' : item.path"
                :exact="item.exact"
                active-class="secondary"
                class="listmenu"
              >
                <div>
                  <span class="jc-c font-sub-menu">{{ item.title }}</span>
                </div>
              </v-list-tile>
              <template class="" v-if="this.name === null || this.name === ''">
                <v-list-tile
                  v-for="item in items_login"
                  :key="item.title"
                  :to="item.path == '' ? '' : item.path"
                  :exact="item.exact"
                  active-class="secondary"
                  class="listmenu"
                >
                  <div>
                    <span class="jc-c font-sub-menu">{{ item.title }}</span>
                  </div>
                </v-list-tile>
              </template>
              <template class="" v-if="this.name !== null && this.name !== ''">
                <v-list-tile active-class="secondary" class="listmenu">
                  <div>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on" flat>
                          <span class="jc-c font-sub-menu"
                            >สวัสดี คุณ{{ name }}</span
                          >
                          <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile
                          v-for="(item, index) in listMenu"
                          :key="index"
                          @click="gotoLink(item.path)"
                        >
                          <v-list-tile-title
                            class="jc-sb"
                            style="display: flex;"
                            >{{ item.title
                            }}<v-icon>{{
                              item.icon
                            }}</v-icon></v-list-tile-title
                          >
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-tile>
              </template>
            </template>
          </v-container>
        </v-toolbar>
      </div>

      <div class="bg-header hidden-md-and-up">
        <v-toolbar color="transparent" id="menu" height="70">
          <v-toolbar-title class="title-menu-mobile">
            <v-toolbar-title class="w-100" style="text-align:center;">
              <span class="w-100 mt-3 title-menu-mobile"
                >รวมใจไทย ปลูกต้นไม้ เพื่อแผ่นดิน</span
              ><br />
              <!-- <span class="w-100 mt-3 title-sub-menu-mobile">เนื่องในโอกาสมหามงคลพระราชพิธีบรมราชาภิเษก</span> -->
            </v-toolbar-title>
          </v-toolbar-title>
        </v-toolbar>
        <div class="ta-c pl-3 pr-3">
          <v-divider></v-divider>
        </div>
        <v-toolbar color="transparent" height="64" id="sub-menu">
          <v-toolbar-items>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" dark v-on="on" flat>
                  <v-icon left dark>menu</v-icon>
                  เมนู
                </v-btn>
              </template>
              <v-list id="sub-menu">
                <v-list-tile
                  v-for="item in items"
                  :key="item.title"
                  :to="item.path == '' ? '' : item.path"
                  :exact="item.exact"
                  active-class="secondary"
                  class="listmenu"
                >
                  <span class="jc-c font-sub-menu-mobile">{{
                    item.title
                  }}</span>
                </v-list-tile>
                <template v-if="this.name === null">
                  <v-list-tile
                    v-for="item in items_login"
                    :key="item.title"
                    :to="item.path == '' ? '' : item.path"
                    :exact="item.exact"
                    active-class="secondary"
                    class="listmenu"
                    @click="gotoLink(item.path)"
                  >
                    <span class="jc-c font-sub-menu-mobile">{{
                      item.title
                    }}</span>
                  </v-list-tile>
                </template>
                <template
                  class=""
                  v-if="this.name !== null && this.name !== ''"
                >
                  <v-list-tile
                    active-class="secondary"
                    class="listmenu"
                    :to="'/edit_profile' == '' ? '' : '/edit_profile'"
                    @click="gotoLink('/edit_profile')"
                  >
                    <v-list-tile-title class="jc-c font-sub-menu-mobile"
                      >แก้ไขข้อมูลส่วนตัว</v-list-tile-title
                    >
                  </v-list-tile>
                </template>
                <template
                  class=""
                  v-if="this.name !== null && this.name !== ''"
                >
                  <v-list-tile
                    active-class="secondary"
                    class="listmenu"
                    @click="gotoLink('/logout')"
                  >
                    <v-list-tile-title class="jc-c font-sub-menu-mobile"
                      >ออกจากระบบ</v-list-tile-title
                    >
                  </v-list-tile>
                </template>
              </v-list>
            </v-menu>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-list-tile class="listmenu h-100" style="align-items:center">
              <v-list-tile-title
                class="jc-c listmenu font-sub-menu-mobile"
                v-if="this.name !== null && this.name !== ''"
                >สวัสดีคุณ {{ this.name }}</v-list-tile-title
              >
            </v-list-tile>
          </v-toolbar-items>
        </v-toolbar>
      </div>

      <v-content class="box-content" style="">
        <v-container pa-0 justify-center align-center flex fill-height>
          <v-layout justify-center align-center fill-height>
            <router-view @getUsername="getUsername" />
          </v-layout>
        </v-container>
      </v-content>
    </v-container>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { title: "บันทึกการปลูกต้นไม้", path: "/seeding" },
        { title: "พันธุ์ไม้ทรงปลูกและต้นไม้น่ารู้", path: "/knowledge" },
        { title: "สถิติการปลูกต้นไม้", path: "/statistic" }
      ],
      items_login: [{ title: "เข้าสู่ระบบ", path: "/login" }],
      name: "",
      emit_cardid: "",
      listMenu: [
        { title: "แก้ไขข้อมูลส่วนตัว", path: "/edit_profile", icon: "edit" },
        { title: "ออกจากระบบ", path: "/logout", icon: "logout" }
      ],
      fullName: ""
    };
  },
  watch: {
    name() {
      this.name = this.name;
    }
  },
  created() {
    this.name = this.$cookies.get("name");
    if (this.$route.path.split("/")[1] === "logout") {
      this.gotoLink("/logout");
    }
  },
  methods: {
    getUsername(name_emit) {
      this.name = name_emit;
    },
    gotoLink(path) {
      // console.log(path);
      if (path === "/logout") {
        this.$cookies.remove("token", "/", process.env.WEB);
        this.$cookies.remove("name", "/", process.env.WEB);
        this.$cookies.remove("fullName", "/", process.env.WEB);
        this.$cookies.remove("company", "/", process.env.WEB);
        this.name = null;
        this.$router.push("/login");
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>
<style scoped>
.bg-home {
  background-image: url("../assets/images/bg-home.jpg");
  background-size: cover;
  background-position: top;
}

.box-content {
  height: calc(100vh - 134px);
  background: white;
  overflow: auto;
}

.title-menu {
  font-size: 44px;
  font-weight: 700;
  white-space: normal !important;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0;
  color: #91601e;
  text-shadow: 2px 1px 10px #ffffff;
}
.title-sub-menu {
  font-size: 30px;
  font-weight: 700;
  white-space: normal !important;
  text-align: center;
  line-height: 0.8;
  letter-spacing: 0;
  color: #b1843d;
  text-shadow: 2px 1px 10px #ffffff;
}

.title-menu-mobile {
  font-size: 30px;
  font-weight: 700;
  white-space: normal !important;
  text-align: center;
  line-height: 1.5;
  letter-spacing: -1px;
  color: #91601e;
  text-shadow: 2px 1px 10px #ffffff;
}
.title-sub-menu-mobile {
  font-size: 22px;
  font-weight: 700;
  white-space: normal !important;
  text-align: center;
  line-height: 1;
  letter-spacing: 0;
  color: #b1843d;
  text-shadow: 2px 1px 10px #ffffff;
}

.font-sub-menu {
  font-size: 24px !important;
  font-weight: 600;
  white-space: nowrap;
}

.font-sub-menu-mobile {
  font-size: 20px !important;
  font-weight: 600;
}

.line-box {
  border-bottom: 1px solid black;
}

.bg-header {
  background-image: url("../assets/images/yellow.jpg");
  background-size: cover;
}

.listmenu {
  justify-content: center;
  display: flex;
  width: 100%;
}
</style>
